import Axios from "./axios"
import {store} from '../redux/store'
import Cookie from 'react-cookies';
import axios from "axios";
import { userData } from "../redux/slices/userSlice";
// import { transactionData } from "../redux/slices/userSlice";
// import { paymentData } from "../redux/slices/paymentSlice";

import { userList as users } from "../redux/slices/userListSlice";
// import { orders } from "../redux/slices/ordersSlice";
// import { transactions } from "../redux/slices/transactionSlice";
// import { todayTransactions } from "../redux/slices/todayTransactionsSlice";
// import { dailyReviews } from "../redux/slices/dailyReviewSlice";
// import {allTimeReviews} from "../redux/slices/allTimeReviews";
import {storeItems} from "../redux/slices/storeItems";
import { updateSlides } from "../redux/slices/sliderSlice";
import { updateEvents } from "../redux/slices/eventSlice";
import { updateGallery } from "../redux/slices/gallerySlice";
import { updateReels } from "../redux/slices/reelSlice";
import { updateMembers } from "../redux/slices/membersSlice";
import {about} from "../redux/slices/about";
import { messages } from "../redux/slices/messageSlice";
import { reviews } from "../redux/slices/reviewsSlice";
// import { notifications } from "../redux/slices/notificationSlice";


export const contactUs = async (data) => {
    try {
        window.start_load();
        const res = await Axios.post('api?contactUs', data);
        // console.log(res.data);
        return res.data
    } catch (err) {
        // console.log(err);
        return err;
    }finally{
        window.stop_load();
    }
}
export const login = async (data) => {
    try{
        window.start_load();
        const res = await Axios.post('/api?login', data);
        if(res.data.success) {
            store.dispatch(userData(res.data.data));
            Cookie.save('token', res.data.token);
            return {
                success: res.data.success,
                message: res.data.message
            }
        
        }else{
            return res.data;
        }
    }catch(err){
        return err.response.data
    }finally{
        window.stop_load();
    }

}
export const register = async (data) => {
    try{
        window.start_load();
        const res = await Axios.post('/api?register', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res);
        store.dispatch(userData(res.data.data));
        Cookie.save('token', res.data.token);
        return res.data;
    }catch(err){
        return err.response.data;
    }finally{
        window.stop_load();
    }
}
export const uData = async (navigate) => {
    // console.log(token);
 try {
    // window.start_load()
    const response = await Axios.get('api?userData', {
        headers: {
            "Authorization": "Bearer "+Cookie.load('token')
        }
    });
    // console.log(response);
    if(response.data.success){
        // console.log(response);
        store.dispatch(userData(response.data.data));
        
    }else{
        navigate('/login');
    }
 } catch (err) {
    navigate('/login');  
 } 
}
export const createUser = async (data) => {
    try{
        window.start_load();
        const res = await Axios.post('/api?newUser', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res);
        return res.data;
    }catch(err){
        return err.response.data;
    }finally{
        window.stop_load();
    }
}
export const updateUser = async (data) => {
    try{
        window.start_load();
        const res = await Axios.post('/api?updateUser', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load();
    }
}
export const changePassword = async (data) => {
    try{
        window.start_load();
        const res = await Axios.post('/api?changePassword', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load();
    }
}
export const userList = async () => {
    // console.log('api called')
    try {
        const response = await Axios.get('api?userList', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        console.log(response.data)
            store.dispatch(updateMembers(response.data.data));
    } catch (err) {
        // console.log(err);
    }
        // else{
        //     return 'Failed, to fetch users list. Check your network and reload page. Or Contact support team for help'
        // }
}
// Slide Management
export const newSlide = async (data) => {
    try{
        window.start_load()
        const res = await Axios.post('/api?newSlide', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const updateAbout = async (data) => {
    try{
        window.start_load()
        const res = await Axios.post('/api?about', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const newGalleryImage = async (data) => {
    try{
        window.start_load()
        const res = await Axios.post('/api?newGalleryImage', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const createEvent = async (data) => {
    try{
        window.start_load()
        const res = await Axios.post('/api?createEvent', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const newHighlight = async (data) => {
    try{
        window.start_load()
        const res = await Axios.post('/api?newHighlight', data, {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getSlides = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getSlides', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        store.dispatch(updateSlides(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getAbout = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getAbout', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        console.log(res.data);
        store.dispatch(about(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err
    }finally{
        window.stop_load()
    }
}

export const getGallery = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getGallery', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        store.dispatch(updateGallery(res.data.data))
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getEvents = async () => {
    // console.log('events testing')
    try{
        window.start_load()
        const res = await Axios.get('/api?getEvents', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        
        store.dispatch(updateEvents(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        // console.log(store);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getAllEvents = async () => {
    // console.log('events testing')
    try{
        window.start_load()
        const res = await Axios.get('/api?getAllEvents', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        
        store.dispatch(updateEvents(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        // console.log(store);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getHighlights = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getHighlights', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        store.dispatch(updateReels(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getMembers = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?userList', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        store.dispatch(updateMembers(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getMessages = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getMessages', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        console.log(res.data);
        store.dispatch(messages(res.data.data))
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}
export const getDashboardSummary = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getDashboardSummary', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        console.log(res.data);
        store.dispatch(reviews(res.data.data))
        // return res.data;
    }catch(err){
        console.log(err);
        // return err.response.data;
    }finally{
        window.stop_load()
    }
}
// Store Management
export const getStoreItems = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?getStoreItems', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        store.dispatch(storeItems(res.data.data));
        // Cookie.save('store', JSON.stringify(res.data.data));
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}

// Order Management
export const saveOrder = async () => {
    try{
        window.start_load()
        const res = await Axios.get('/api?saveOrder', {
            headers: {
                "Authorization": "Bearer "+Cookie.load('token')
            }
        });
        // console.log(res.data);
        return res.data;
    }catch(err){
        // console.log(err);
        return err.response.data;
    }finally{
        window.stop_load()
    }
}

   

